<template>
  <v-form>
    <v-container fluid>
      <v-row>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="modelSelectItems"
            v-model="item.model"
            :items="modelSelectItems"
            :error-messages="modelErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.machine.model')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        
        <v-col cols="12" sm="6" md="6">
          <p>Format : x.x.x (1.0.0, 1.2.1, 1.0.0-ALPHA.1, 1.0.0-R.1, ...)</p>
          <v-text-field
            v-model="item.version"
            :error-messages="versionErrors"
            :label="$t('profile.machine.version')"
            required
            @input="$v.item.version.$touch()"
            @blur="$v.item.version.$touch()"
          />
        </v-col>

      </v-row>

      <v-row>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="controlUnitSelectItems"
            v-model="item.controlUnit"
            :items="controlUnitSelectItems"
            :error-messages="controlUnitErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.controlunit.controlunit')"
            item-text="name"
            item-value="@id"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="industrialComputerSelectItems"
            v-model="item.industrialComputer"
            :items="industrialComputerSelectItems"
            :error-messages="industrialComputerErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.industrialcomputer.industrialcomputer')"
            item-text="name"
            item-value="@id"
          />
        </v-col>

      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="operatingSystemSelectItems"
            v-model="item.operatingSystem"
            :items="operatingSystemSelectItems"
            :error-messages="operatingSystemErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.operatingsystem.operatingsystem')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="softwareVersionSelectItems"
            v-model="item.softwareVersion"
            :items="softwareVersionSelectItems"
            :error-messages="softwareVersionErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.software.versions')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="printingSurfaceSelectItems"
            v-model="item.printingSurface"
            :items="printingSurfaceSelectItems"
            :error-messages="printingSurfaceErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.printingsurface.printingsurface')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6"  v-if="!item['@id']">
          <v-combobox
            v-if="machineSelectItems"
            v-model="item.parent"
            :items="machineSelectItems"
            :error-messages="parentErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            :label="$t('profile.machine.parent')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <strong class="ml-4" >{{ $t('global.archive') }}:</strong>
          <v-switch
                v-model="item.archive"
                :error-messages="archiveErrors"
              ></v-switch>
        </v-col>
      </v-row>
    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';

export default {
  name: 'MachineForm',
  mixins: [validationMixin],
  components: {
    Loading
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
      this.modelGetSelectItems();


      this.controlUnitGetSelectItems();
      this.industrialComputerGetSelectItems();
      this.softwareVersionGetSelectItems();
      this.operatingSystemGetSelectItems();
      this.printingSurfaceGetSelectItems();
      this.machineGetSelectItems({'query'  : [{'id': 'exists[parent]', 'value': 0 }]  });
  },
  data() {
    return {
        model: null,
        version: null,
        parent: null,
        controlUnit: null,
        industrialComputer: null,
        softwareVersion: null,
        operatingSystem: null,
        printingSurface: null,
        archive: null,
    };
  },
  computed: {
      isLoading() {
        return (this.isLoading_machinemodel ||
           this.isLoading_controlUnit ||
           this.isLoading_industrialComputer ||
           this.isLoading_operatingSystem ||
           this.isLoading_printingSurface ||
           this.isLoading_machine ||
           this.isLoading_softwareVersion
         );
      },
      ...mapFields('machinemodel', {
        modelSelectItems: 'selectItems',
        isLoading_machinemodel : 'isLoading'
      }),
      ...mapFields('machine', {
        machineSelectItems: 'selectItems',
        isLoading_machine : 'isLoading'
      }),
      ...mapFields('controlunit', {
        controlUnitSelectItems: 'selectItems',
        isLoading_controlUnit : 'isLoading'
      }),
      ...mapFields('industrialcomputer', {
        industrialComputerSelectItems: 'selectItems',
        isLoading_industrialComputer : 'isLoading'
      }),
      ...mapFields('operatingsystem', {
        operatingSystemSelectItems: 'selectItems',
        isLoading_operatingSystem : 'isLoading'
      }),
      ...mapFields('printingsurface', {
        printingSurfaceSelectItems: 'selectItems',
        isLoading_printingSurface : 'isLoading'
      }),
      ...mapFields('softwareversion', {
        softwareVersionSelectItems: 'selectItems',
        isLoading_softwareVersion : 'isLoading'
      }),

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },
    modelErrors() {
      const errors = [];

      if (!this.$v.item.model.$dirty) return errors;

      has(this.violations, 'model') && errors.push(this.violations.model);


      return errors;
    },
    versionErrors() {
      const errors = [];

      if (!this.$v.item.version.$dirty) return errors;

      has(this.violations, 'version') && errors.push(this.violations.version);


      return errors;
    },
    controlUnitErrors() {
      const errors = [];
      if (!this.$v.item.controlUnit.$dirty) return errors;
      has(this.violations, 'controlUnit') && errors.push(this.violations.controlUnit);
      return errors;
    },
    industrialComputerErrors() {
      const errors = [];
      if (!this.$v.item.industrialComputer.$dirty) return errors;
      has(this.violations, 'industrialComputer') && errors.push(this.violations.industrialComputer);
      return errors;
    },
    operatingSystemErrors() {
      const errors = [];
      if (!this.$v.item.operatingSystem.$dirty) return errors;
      has(this.violations, 'operatingSystem') && errors.push(this.violations.operatingSystem);
      return errors;
    },
    printingSurfaceErrors() {
      const errors = [];
      if (!this.$v.item.printingSurface.$dirty) return errors;
      has(this.violations, 'printingSurface') && errors.push(this.violations.printingSurface);
      return errors;
    },
    softwareVersionErrors() {
      const errors = [];
      if (!this.$v.item.softwareVersion.$dirty) return errors;
      has(this.violations, 'softwareVersion') && errors.push(this.violations.softwareVersion);
      return errors;
    },
    parentErrors() {
      const errors = [];
      if (!this.$v.item.parent.$dirty) return errors;
      has(this.violations, 'parent') && errors.push(this.violations.parent);
      return errors;
    },
    archiveErrors() {
      const errors = [];
      if (!this.$v.item.archive.$dirty) return errors;
      has(this.violations, 'archive') && errors.push(this.violations.archive);
      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {
      ...mapActions({
        modelGetSelectItems: 'machinemodel/fetchSelectItems'
      }),
      ...mapActions({
        controlUnitGetSelectItems: 'controlunit/fetchSelectItems'
      }),
      ...mapActions({
        industrialComputerGetSelectItems: 'industrialcomputer/fetchSelectItems'
      }),
      ...mapActions({
        operatingSystemGetSelectItems: 'operatingsystem/fetchSelectItems'
      }),
      ...mapActions({
        printingSurfaceGetSelectItems: 'printingsurface/fetchSelectItems'
      }),
      ...mapActions({
        softwareVersionGetSelectItems: 'softwareversion/fetchSelectItems'
      }),
      ...mapActions({
        machineGetSelectItems: 'machine/fetchSelectItems'
      }),
  },
  validations: {
    item: {
      model: {
      },
      version: {
      },
      parent: {
      },
      controlUnit: {
      },
      industrialComputer: {
      },
      operatingSystem: {
      },
      printingSurface: {
      },
      softwareVersion: {
      },
      archive: {

      },
    }
  }
};
</script>
